/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Image, Breadcrumb } from "antd";
import closeImg from "../../../../assets/images/icon_menus/Close Button.svg";
import customStyles from "../../../../assets/styles/customStyles";
import clsx from 'clsx';
import { storageGetItem, idNamingConversion } from '../../../../helpers/utilities';
import { useSelector } from "react-redux";
import lottie from 'lottie-web';
import { useEventListener } from "../../../../helpers/useEventListener"


export const BreadCrumbNew = (props) => {
    const { title, links, img, cls, close, history, type, closeLink, handleCloseClick } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);

    const animationContainer = useRef(null);
    const classes = customStyles();
    const [previous, setPrevious] = useState(false);
    //const [days, setDays] = useState(0);

    useEffect(() => {
        if (history?.location?.state === 'edit' || history?.location?.state === 'create') {
            setPrevious(history?.location?.state);
        } else if (history?.location?.state === 'catalogue') {
            setPrevious(history?.location?.state);
        }
    }, [type]);

    // useEffect(() => {
    //     if (subscriptionDetails?.subscriptionEndDate) {
    //         let date1 = new Date();
    //         let date2 = new Date(subscriptionDetails?.subscriptionEndDate);
    //         let Difference_In_Time = date2.getTime() - date1.getTime();
    //         setDays(Math.round(Difference_In_Time / (1000 * 3600 * 24)));
    //     }
    // }, [subscriptionDetails]);

    useEffect(() => {
        const instance = lottie.loadAnimation({
            container: animationContainer.current, // the dom element
            renderer: 'svg',
            loop: false,
            autoplay: true,
            animationData: img
        });
        // Return clean up function here
        return () => instance.destroy();
    }, [img]);


    const handleHistory = () => {
        if (handleCloseClick) {
            handleCloseClick();
        } else {
            if (closeLink && closeLink !== '') {
                history.push(closeLink);
            } else {
                history.go(previous ? (previous === 'catalogue' ? -3 : -2) : -1)
            }
        }
    }

    const handleKeyDown = (e) => {
        if (e.keyCode === 27) {
            e.preventDefault();
            handleHistory();
        } else if (e.ctrlKey && e.keyCode === 49) { // CTRL + 1
            e.preventDefault();
            history.push('/sales/sales-management/self-bill');
        } else if (e.ctrlKey && e.keyCode === 50) { // CTRL + 2
            e.preventDefault();
            history.push('/sales/sales-management/customer-payment');
        } else if (e.ctrlKey && e.keyCode === 51) { // CTRL + 3
            e.preventDefault();
            history.push('/sales/sales-management/all-customers');
        } else if (e.ctrlKey && e.keyCode === 52) { // CTRL + 4
            e.preventDefault();
            history.push('/sales/transactions/customer-transactions');
        } else if (e.ctrlKey && e.keyCode === 53) { // CTRL + 5
            e.preventDefault();
            history.push('/sales/transactions/invoice-history');
        } else if (e.ctrlKey && e.keyCode === 54) {   // CTRL + 6
            e.preventDefault();
            history.push('/sales/sales-management/sales-quote');
        } else if (e.ctrlKey && e.keyCode === 55) {   // CTRL + 7
            e.preventDefault();
            history.push('/sales/sales-management/store-sales');
        } else if (e.ctrlKey && e.keyCode === 56) {   // CTRL + 8
            e.preventDefault();
            history.push('/sales/sales-management/sales-order');
        } else if (e.altKey && e.keyCode === 49) { // ALT + 1
            e.preventDefault();
            history.push('/purchase/purchase-management/self-bill');
        } else if (e.altKey && e.keyCode === 50) { // ALT + 2
            e.preventDefault();
            history.push('/purchase/purchase-management/supplier-payment');
        } else if (e.altKey && e.keyCode === 51) { // ALT + 3
            e.preventDefault();
            history.push('/purchase/purchase-management/all-suppliers');
        } else if (e.altKey && e.keyCode === 52) { // ALT + 4
            e.preventDefault();
            history.push('/purchase/transactions/supplier-transactions');
        } else if (e.altKey && e.keyCode === 53) { // ALT + 5
            e.preventDefault();
            history.push('/purchase/transactions/invoice-history');
        } else if (e.altKey && e.keyCode === 54) { // ALT + 6
            e.preventDefault();
            history.push('/purchase/purchase-management/supply-quote');
        } else if (e.altKey && e.keyCode === 55) { // ALT + 7
            e.preventDefault();
            history.push('/purchase/purchase-management/purchase-order');
        } else if (e.altKey && e.keyCode === 57) { // ALT + 9
            e.preventDefault();
            history.push('/product/product/my-products');
        } else if (e.altKey && e.keyCode === 56) { // ALT + 8
            e.preventDefault();
            history.push('/product/setup/maintain-price');
        } else if (e.altKey && e.keyCode === 67) {
            e.preventDefault();
            history.push('/sales/setup/sales-price');
        } else if (e.altKey && e.keyCode === 71) {
            e.preventDefault();
            history.push('/admin/report-enquiry/gst-transactions');
        } else if (e.ctrlKey && e.keyCode === 79) {
            e.preventDefault();
            history.push('/admin/batch-process/price-list/outbound');
        } else if (e.ctrlKey && e.keyCode === 81) {
            e.preventDefault();
            history.push('/admin/batch-process/price-list/inbound');
        } else if (e.altKey && e.keyCode === 86) {
            e.preventDefault();
            history.push('/purchase/setup/purchase-price');
        } else if (e.keyCode === 123 ||
            (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0))
            || (e.ctrlKey && e.shiftKey && e.keyCode === 'J'.charCodeAt(0))
            || (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0))) {
            e.preventDefault();
        }
    };

    useEventListener("keydown", handleKeyDown);

    return (
        <div className={clsx(classes.breadBg, classes.customZoom)}>
            {/* {
                subscriptionDetails?.subscriptionEndDate && days <= 7 && days !== 0 && <div className={classes.subscriptionExpired}>
                    {
                        days < 0 ? <span>{`Your plan has been expired`}</span> : <span>{`Your plan expires in ${days} days`}</span>
                    }
                    <Link to="/admin/home/billings" tabIndex={-1} className={classes.modalBtn}>Upgrade</Link>
                </div>
            } */}
            <div className={classes.colorBg}></div>
            <div className={classes.dFlex}>
                <div className={clsx(classes.breadImg, cls)}>
                    <div ref={animationContainer} style={{ width: '96%', height: '96%' }}></div>
                </div>
                <div className={classes.breadTitle}>
                    <div className={classes.breadTit}>{title}</div>
                    <Breadcrumb className={classes.breadTitleChild} style={{ marginTop: 0, marginLeft: 0, color: '#317787' }}>
                        <Breadcrumb.Item key={0}></Breadcrumb.Item>
                        {
                            links && links.map((item, i) => (
                                <React.Fragment key={i}>
                                    {
                                        item.link !== '' ?
                                            <Breadcrumb.Item><Link tabIndex={-1} to={item.link}>{item.label}</Link></Breadcrumb.Item>
                                            :
                                            <Breadcrumb.Item>{item.label}</Breadcrumb.Item>
                                    }
                                </React.Fragment>
                            ))
                        }
                    </Breadcrumb>
                </div>
                {
                    storageGetItem('deviceToken') === null && <div className={classes.notificationBar}>Please enable the notification permission in browser for live notification 🔔</div>
                }

                {
                    close !== false && <div className={classes.CloseIcon}>
                        <Image className={clsx(classes.disInline, classes.cursor)} id={idNamingConversion('Close', 'burgerMenu', 'Icon')} onClick={() => handleHistory()}
                            src={closeImg}
                            preview={false}
                        />
                    </div>
                }
            </div>
            {
                businessDetails?.businessName && <div className={classes.customBusinessName}>{businessDetails?.businessName}</div>
            }
        </div>
    );
}
